import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

export function AppIconRedo({ size = 20, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_ICON_SUCCESS

  return (
    <Svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <Path
        fill={fill}
        d="M14.0049 4.10456C14.3564 3.75309 14.9268 3.75309 15.2783 4.10456L17.4111 6.23835C17.7626 6.58982 17.7626 7.15935 17.4111 7.51081L15.2783 9.6446C14.9269 9.99603 14.3563 9.99603 14.0049 9.6446C13.6535 9.29314 13.6535 8.72263 14.0049 8.37116L14.5508 7.82526H7.39258C5.58963 7.82526 4.12598 9.28892 4.12598 11.0919C4.12619 12.8946 5.58977 14.3585 7.39258 14.3585H14.0586C14.5553 14.3587 14.9588 14.7611 14.959 15.2579C14.9589 15.7547 14.5554 16.158 14.0586 16.1583H7.39258C4.59565 16.1583 2.32443 13.8887 2.32422 11.0919C2.32422 8.29481 4.59552 6.02448 7.39258 6.02448H14.6514L14.0049 5.378C13.6534 5.02654 13.6534 4.45603 14.0049 4.10456Z"
      />
    </Svg>
  )
}
